// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { IInvestmentDetailsDtoHoldingsInner } from './IInvestmentDetailsDtoHoldingsInner';
import {
    IInvestmentDetailsDtoHoldingsInnerFromJSON,
    IInvestmentDetailsDtoHoldingsInnerFromJSONTyped,
    IInvestmentDetailsDtoHoldingsInnerToJSON,
    IInvestmentDetailsDtoHoldingsInnerToJSONTyped,
} from './IInvestmentDetailsDtoHoldingsInner';

/**
 * 
 * @export
 * @interface IInvestorAccountDto
 */
export interface IInvestorAccountDto {
    /**
     * 
     * @type {number}
     * @memberof IInvestorAccountDto
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof IInvestorAccountDto
     */
    external_id?: string;
    /**
     * 
     * @type {number}
     * @memberof IInvestorAccountDto
     */
    investor_id?: number;
    /**
     * 
     * @type {number}
     * @memberof IInvestorAccountDto
     */
    banking_account_id?: number;
    /**
     * 
     * @type {string}
     * @memberof IInvestorAccountDto
     */
    external_number?: string;
    /**
     * 
     * @type {string}
     * @memberof IInvestorAccountDto
     */
    status?: IInvestorAccountDtoStatusEnum;
    /**
     * 
     * @type {number}
     * @memberof IInvestorAccountDto
     */
    cash_balance?: number;
    /**
     * 
     * @type {number}
     * @memberof IInvestorAccountDto
     */
    equity_value?: number;
    /**
     * 
     * @type {string}
     * @memberof IInvestorAccountDto
     */
    ria_user_external_id?: string;
    /**
     * 
     * @type {string}
     * @memberof IInvestorAccountDto
     */
    ria_product_external_id?: string;
    /**
     * 
     * @type {Array<IInvestmentDetailsDtoHoldingsInner>}
     * @memberof IInvestorAccountDto
     */
    holdings?: Array<IInvestmentDetailsDtoHoldingsInner>;
    /**
     * 
     * @type {string}
     * @memberof IInvestorAccountDto
     */
    managed_type?: IInvestorAccountDtoManagedTypeEnum;
    /**
     * 
     * @type {number}
     * @memberof IInvestorAccountDto
     */
    buy_pending_amount?: number;
    /**
     * 
     * @type {number}
     * @memberof IInvestorAccountDto
     */
    sell_pending_amount?: number;
}

/**
* @export
* @enum {string}
*/
export enum IInvestorAccountDtoStatusEnum {
    PENDING = 'PENDING',
    OPEN = 'OPEN',
    OPEN_NO_NEW_TRADES = 'OPEN_NO_NEW_TRADES',
    CLOSED = 'CLOSED',
    FROZEN = 'FROZEN'
}
/**
* @export
* @enum {string}
*/
export enum IInvestorAccountDtoManagedTypeEnum {
    SELF = 'SELF',
    ADVISORY = 'ADVISORY',
    RIA_MANAGED = 'RIA_MANAGED',
    CUSTODIAL = 'CUSTODIAL',
    CUSTODIAL_MANAGED = 'CUSTODIAL_MANAGED',
    RESERVED = 'RESERVED',
    RETIREMENT_TRADITIONAL_SELF = 'RETIREMENT_TRADITIONAL_SELF',
    RETIREMENT_TRADITIONAL_ADVISORY = 'RETIREMENT_TRADITIONAL_ADVISORY',
    RETIREMENT_TRADITIONAL_RIA_MANAGED = 'RETIREMENT_TRADITIONAL_RIA_MANAGED',
    RETIREMENT_ROTH_SELF = 'RETIREMENT_ROTH_SELF',
    RETIREMENT_ROTH_ADVISORY = 'RETIREMENT_ROTH_ADVISORY',
    RETIREMENT_ROTH_RIA_MANAGED = 'RETIREMENT_ROTH_RIA_MANAGED',
    TRUST_SELF = 'TRUST_SELF',
    TRUST_ADVISORY = 'TRUST_ADVISORY',
    TRUST_RIA_MANAGED = 'TRUST_RIA_MANAGED'
}


/**
 * Check if a given object implements the IInvestorAccountDto interface.
 */
export function instanceOfIInvestorAccountDto(value: object): value is IInvestorAccountDto {
    return true;
}

export function IInvestorAccountDtoFromJSON(json: any): IInvestorAccountDto {
    return IInvestorAccountDtoFromJSONTyped(json, false);
}

export function IInvestorAccountDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IInvestorAccountDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'external_id': json['external_id'] == null ? undefined : json['external_id'],
        'investor_id': json['investor_id'] == null ? undefined : json['investor_id'],
        'banking_account_id': json['banking_account_id'] == null ? undefined : json['banking_account_id'],
        'external_number': json['external_number'] == null ? undefined : json['external_number'],
        'status': json['status'] == null ? undefined : json['status'],
        'cash_balance': json['cash_balance'] == null ? undefined : json['cash_balance'],
        'equity_value': json['equity_value'] == null ? undefined : json['equity_value'],
        'ria_user_external_id': json['ria_user_external_id'] == null ? undefined : json['ria_user_external_id'],
        'ria_product_external_id': json['ria_product_external_id'] == null ? undefined : json['ria_product_external_id'],
        'holdings': json['holdings'] == null ? undefined : ((json['holdings'] as Array<any>).map(IInvestmentDetailsDtoHoldingsInnerFromJSON)),
        'managed_type': json['managed_type'] == null ? undefined : json['managed_type'],
        'buy_pending_amount': json['buy_pending_amount'] == null ? undefined : json['buy_pending_amount'],
        'sell_pending_amount': json['sell_pending_amount'] == null ? undefined : json['sell_pending_amount'],
    };
}

export function IInvestorAccountDtoToJSON(json: any): IInvestorAccountDto {
    return IInvestorAccountDtoToJSONTyped(json, false);
}

export function IInvestorAccountDtoToJSONTyped(value?: IInvestorAccountDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'external_id': value['external_id'],
        'investor_id': value['investor_id'],
        'banking_account_id': value['banking_account_id'],
        'external_number': value['external_number'],
        'status': value['status'],
        'cash_balance': value['cash_balance'],
        'equity_value': value['equity_value'],
        'ria_user_external_id': value['ria_user_external_id'],
        'ria_product_external_id': value['ria_product_external_id'],
        'holdings': value['holdings'] == null ? undefined : ((value['holdings'] as Array<any>).map(IInvestmentDetailsDtoHoldingsInnerToJSON)),
        'managed_type': value['managed_type'],
        'buy_pending_amount': value['buy_pending_amount'],
        'sell_pending_amount': value['sell_pending_amount'],
    };
}

